import {
  S3Client,
  ListObjectsV2Command,
  GetObjectCommand,
  DeleteObjectCommand,
  PutObjectCommand,
  HeadObjectCommand
} from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';
import { FileDTO } from '@data/models/file-dto';

export class AwsS3Client {
  constructor(private bucket: string, private client: S3Client) {}

  public async list(prefix: string): Promise<FileDTO[]> {
    const result: FileDTO[] = [];

    const command = new ListObjectsV2Command({
      Bucket: this.bucket,
      Prefix: prefix.slice(1)
    });

    const response = await this.client.send(command);

    if (response.Contents) {
      for (const obj of response.Contents) {
        const path = obj.Key?.split('/') || [];
        const contentType = await this.getContentType(obj.Key);
        result.push({
          data: new File([], path[path.length - 1], { type: contentType || '' }), // ContentType not available here
          thumbnail:
            obj.Key && path[path.length - 1].match(/\.(jpg|jpeg|png|gif|mp4|pdf)$/i)
              ? this.parseFileURL(obj.Key)
              : './assets/img/default-file.png',
          template: prefix.toLowerCase().includes('template'),
          SavedOnAzure: true
        });
      }
    }

    return result;
  }

  public async download(relativePath: string, name: string, handler: (blob: Blob) => void): Promise<void> {
    const key = `${relativePath}/${name}`.replace(/\/+/, '/');

    const command = new GetObjectCommand({
      Bucket: this.bucket,
      Key: key
    });

    const response = await this.client.send(command);
    if (response.Body) {
      const reader = response.Body as ReadableStream<Uint8Array>;
      const blob = await new Response(reader).blob();
      handler(blob);
    }
  }

  public async delete(relativePath: string, name: string, handler: () => void): Promise<void> {
    const key = `${relativePath}/${name}`.replace(/\/+/, '/').slice(1);

    const command = new DeleteObjectCommand({
      Bucket: this.bucket,
      Key: key
    });

    await this.client.send(command);
    handler();
  }

  public async upload(relativePath: string, content: Blob, name: string, handler: () => void): Promise<void> {
    const key = `${relativePath}/${name}`.replace(/\/+/, '/').slice(1);

    const upload = new Upload({
      client: this.client,
      params: {
        Bucket: this.bucket,
        Key: key,
        Body: content,
        ContentType: content.type
      }
    });

    await upload.done();
    handler();
  }
  private async getContentType(key: string): Promise<string | undefined> {
    try {
      const command = new HeadObjectCommand({
        Bucket: this.bucket,
        Key: key
      });

      const response = await this.client.send(command);
      return response.ContentType;
    } catch (error) {
      console.error(`Errore nel recupero ContentType per ${key}:`, error);
      return undefined;
    }
  }

  private parseFileURL(key: string): string {
    return `https://${this.bucket}.s3.amazonaws.com/${key}`;
  }
}
